import React, { useMemo } from "react";
import CarFilterBase from "./CarFilterBase";
import { ComponentRegistryProvider } from "./componentRegistry";
import FilterSavedCars from "./filters/FilterSavedCars";
import MobileStaticFilterBar from "./active-filters/top-bar/MobileStaticFilterBar";
import StaticFilterBar from "./active-filters/top-bar/StaticFilterBar";
import UsedCarResult from "./car-results/df-car-result/UsedCarResult";
import IntegratedUsedCompareWrapper from "./IntegratedUsedCompareWrapper";
import CarResultsContainerWrapper from "./car-results/CarResultsContainerWrapper";
import PageFinanceDisclaimer from "../../../shared-components/lexus/page-finance-disclaimer/PageFinanceDisclaimer";

const CarFilter = (): JSX.Element => {
    const componentRegistry = useMemo(
        () => ({
            FilterSavedCars,
            MobileStaticFilterBar,
            StaticFilterBar,
            UsedCarResult,
            IntegratedUsedCompareWrapper,
            CarResultsContainerWrapper,
            PageFinanceDisclaimer,
        }),
        [],
    );

    return (
        <ComponentRegistryProvider registry={componentRegistry}>
            <CarFilterBase />
        </ComponentRegistryProvider>
    );
};

export default CarFilter;
